{
  "loading": "読み込み中…",
  "save": "保存",
  "saving": "保存中…",
  "cancel": "キャンセル",
  "close": "閉じる",
  "confirm": "確認",
  "back": "戻る",
  "next": "次へ",
  "search": "検索",
  "filter": "絞り込み",
  "clear": "クリア",
  "viewAll": "すべて見る",
  "retry": "再試行",
  "yes": "はい",
  "no": "いいえ",
  "none": "なし",
  "empty": "表示できる内容はまだありません",
  "saved": "保存しました",
  "language": "言語",
  "languageDescription": "メールや通知を含め、BidNova Auctions 全体で使用する言語を選択します。",
  "languageSaved": "言語を更新しました",
  "loadingLabel": "読み込み中",
  "retrying": "再試行中…",
  "nothingToShow": "表示できる項目はまだありません。",
  "errorTitle": "問題が発生しました",
  "errorBody": "現在この内容を読み込めませんでした。",
  "viewOrder": "注文を見る",
  "signIn": "ログイン",
  "signOut": "ログアウト"
}
